import React from "react";
import { Modal, Row, Button } from "react-bootstrap";
import config from "../../config/config";
import CopyToClipboard from "react-copy-to-clipboard";

const NftboxLoadModal = ({ showModalLoad, buyTransactionHash, copieBtn, redirect }) => {
  return (
    <Modal
      show={showModalLoad}
      className="walker_detail"
      centered
      size="l"
      backdrop="static"
    >
      <Modal.Body>
        <Row>
          <div className="" style={{ display: "grid" }}>
            <p style={{ margin: "auto" }}>
              Your transaction is in Progress
            </p>
            <p style={{ margin: "auto" }}>
              It will take some time to reflect to your account
            </p>
            <p style={{ margin: "auto" }}>
              Your can check your transaction by visiting{" "}
              <a href={`${config.bsc_url}/${buyTransactionHash}`} target="_blank">
                {buyTransactionHash.slice(0, 4) + "..." + buyTransactionHash.slice(-4)}
              </a>
              <CopyToClipboard text={buyTransactionHash}>
                <span
                  title="Click to Copy"
                  className="mr-copylink"
                  id="token-buy-button"
                  onClick={copieBtn}
                  style={{ cursor: "pointer", color: "#fff" }}
                >
                  &nbsp;<i className="fa fa-clone "></i>
                </span>
              </CopyToClipboard>{" "}
            </p>
          </div>showNftSuccessModal
        </Row>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="secondary" onClick={redirect}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NftboxLoadModal;